import React from 'react';

import {
  Route,
  Redirect
} from 'react-router-dom';


import PropTypes from 'prop-types';



function PrivateRoute({ children, isAuthenticated, ...rest }) {
  const currentLocation=window.location.href;
  if(isAuthenticated) return (
    <Route {...rest} render={ ({ location }) => ( children ) }/>
    );
  else
  return (
  <Redirect to={{ pathname: '/login', state: { from: currentLocation }}} />     
  );
}

export { PrivateRoute }


// WEBPACK FOOTER //
// ./src/routes/PrivateRoute/PrivateRoute.js